import { intercepted2ogpsikxxj4u0 as intercepted } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { CancellableContinuationImpl1cx201opicavg as CancellableContinuationImpl } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CancellableContinuationImpl.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  Companion_instance25ullnynvxd0w as Companion_instance,
  _Result___init__impl__xyqfz83a5421h46yeyh as _Result___init__impl__xyqfz8,
  createFailure8paxfkfa5dc7 as createFailure,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/Result.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function requireNodeFetch() {
  return eval('require')('node-fetch');
}
function AbortController_0() {
  return new AbortController();
}
function asByteArray(_this__u8e3s4) {
  // Inline function 'kotlin.js.asDynamic' call
  return new Int8Array(_this__u8e3s4.buffer, _this__u8e3s4.byteOffset, _this__u8e3s4.length);
}
function readChunk(_this__u8e3s4, $completion) {
  var cancellable = new (CancellableContinuationImpl())(intercepted($completion), 1);
  cancellable.c11();
  var continuation = cancellable;
  var tmp = _this__u8e3s4.read();
  var tmp_0 = tmp.then((it) => {
    var chunk = it.value;
    var result = it.done ? null : chunk;
    // Inline function 'kotlin.coroutines.resume' call
    var this_0 = continuation;
    // Inline function 'kotlin.Companion.success' call
    var tmp$ret$0 = _Result___init__impl__xyqfz8(result);
    this_0.tc(tmp$ret$0);
    return Unit_instance;
  });
  tmp_0.catch((cause) => {
    // Inline function 'kotlin.coroutines.resumeWithException' call
    var this_0 = continuation;
    // Inline function 'kotlin.Companion.failure' call
    var tmp$ret$2 = _Result___init__impl__xyqfz8(createFailure(cause));
    this_0.tc(tmp$ret$2);
    return Unit_instance;
  });
  return cancellable.my();
}
//region block: exports
export {
  AbortController_0 as AbortController21osa5gzjz756,
  asByteArray as asByteArray2l3hscb95qi13,
  requireNodeFetch as requireNodeFetch19juc7kebtu9r,
  readChunk as readChunk37iql29cqo40z,
};
//endregion

//# sourceMappingURL=Js.mjs.map
